module.exports = __webpack_public_path__ + "img/2025-05-09c_7.9707e683.jpg";